import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { toQueryString } from '../../../../util';

const Stream = ({ stream, pathName, queryParams }) => (
	<div key={`navigate-to-stream-${stream.id}`}>
		<Link
			id={`stream-navigation-btn-${stream.id}`}
			to={{ pathname: `${pathName}/streams/${stream.id}`, search: toQueryString(queryParams) }}
		>
			{stream.title}
		</Link>
	</div>
);

Stream.propTypes = {
	pathName: PropTypes.string.isRequired,
};

Stream.defaultProps = {};

export default Stream;



// WEBPACK FOOTER //
// ./src/ui/streams/children/stream/Stream.component.js